const controllers = require('../Http/Controllers')


module.exports = {
  home: {
    component: controllers.HomepageController,
    path: '/',
    name: 'home',
  },
  video: {
    component: controllers.VideoController,
    path: '/video',
    name: 'video',
  },
  notFound: {
    component: controllers.NotFoundController,
    path: '/404',
    name: 'notFound',
  },
  /* Regular users */
  game: {
    component: controllers.GameController,
    path: '/game',
    name: 'game',
  },
  gameWait: {
    component: controllers.GameWaitController,
    path: '/game/wait',
    name: 'gameWait',
  },
  gameError: {
    component: controllers.GameErrorController,
    path: '/game/error',
    name: 'gameError',
  },
  gameOverload: {
    component: controllers.GameOverloadController,
    path: '/game/overload',
    name: 'gameOverload',
  },
  looks: {
    component: controllers.LooksController,
    path: '/looks',
    name: 'looks',
  },
  gridDefault: {
    component: controllers.GridDefaultController,
    path: '/grid',
    name: 'gridDefault',
  },
  gridPreset: {
    component: controllers.GridPresetController,
    path: '/grid/:slug',
    name: 'grid',
  },
  page: {
    component: controllers.PageController,
    path: '/:slug',
    name: 'page',
  },
  /* VIP users */
  vr: {
    component: controllers.VRController,
    path: '/show',
    name: 'vr',
    isVip: true,
  },
  vipLanding: {
    component: controllers.HomepageController,
    path: '/show/landing',
    name: 'vipLanding',
    isVip: true,
  },
  code: {
    component: controllers.CodeController,
    path: '/show/code',
    name: 'code',
    isVip: true,
  },
  onboarding: {
    component: controllers.OnboardingController,
    path: '/show/tutorial',
    name: 'onboarding',
    isVip: true,
  },
  vipGame: {
    component: controllers.GameController,
    path: '/show/game',
    name: 'vipGame',
    isVip: true,
  },
  vipGameWait: {
    component: controllers.GameWaitController,
    path: '/show/game/wait',
    name: 'vipGameWait',
    isVip: true,
  },
  vipGameError: {
    component: controllers.GameErrorController,
    path: '/show/game/error',
    name: 'vipGameError',
    isVip: true,
  },
  vipGameOverload: {
    component: controllers.GameOverloadController,
    path: '/show/game/overload',
    name: 'vipGameOverload',
    isVip: true,
  },
  vipLooks: {
    component: controllers.LooksController,
    path: '/show/looks',
    name: 'vipLooks',
    isVip: true,
  },
  vipGridDefault: {
    component: controllers.GridDefaultController,
    path: '/show/grid',
    name: 'vipGridDefault',
    isVip: true,
  },
  vipGridPreset: {
    component: controllers.GridPresetController,
    path: '/show/grid/:slug',
    name: 'vipGridPreset',
    isVip: true,
  },
  vipPage: {
    component: controllers.PageController,
    path: '/show/:slug',
    name: 'vipPage',
    isVip: true,
  },
}
